/**
 * A service type's colour on the Revenue page: one of the eight categorical tokens in
 * `styles/theme.css` (`--sw-service-type-1` … `--sw-service-type-8`, light and dark), given out by the type's
 * place in the shop's list, so a type keeps its colour whatever the period or the amounts. A
 * colour that followed the row's RANK would repaint every type the day two of them swap places.
 *
 * A shop with more than eight types sees the hues come round again from the ninth. That is
 * tolerable only because colour is never the only carrier here: every row names its type.
 */
/** How many hues there are: one `--sw-service-type-N` token each, in every theme. */
export const SERVICE_TYPE_HUES = 8;

export function serviceTypeColour(sortOrder: number): string {
  const slot =
    (((sortOrder % SERVICE_TYPE_HUES) + SERVICE_TYPE_HUES) % SERVICE_TYPE_HUES) + 1;
  return `var(--sw-service-type-${slot})`;
}
